import { useSetupCampaigns } from '@state/useSetupCampaigns';

/**
 * Demo / sample-data banner. A single thin strip at the top of every screen,
 * shown ONLY when the global `demo_mode` setting is true. It replaces the
 * full-page watermark overlay for demo tenants. Inert (renders null) for any
 * tenant that does not set demo_mode, so production tenants are unaffected.
 * Reads `demoMode` from the same `useSetupCampaigns` global store that
 * WatermarkOverlay reads `watermarkMode` from. Uses `.demo-banner` (index.css).
 */
const DEFAULT_TEXT = 'DEMO · SAMPLE DATA · NOT FOR PRODUCTION USE';

export function DemoDataBanner() {
  const global = useSetupCampaigns((s) => s.global);
  if (!global?.demoMode) return null;
  const text = (global.demoBannerText && global.demoBannerText.trim()) || DEFAULT_TEXT;
  return (
    <div className="demo-banner" role="note" aria-label="Demo mode" data-print-hide>
      <span className="dot" />
      <span>{text}</span>
    </div>
  );
}
